import React from 'react';

import ResultSuccess from './ResultSuccess';
import {Result, SelectResult} from '../components';
import {EXECUTION_STATUS} from '../constants';
import {getRowsDuration} from './utils';

import './Result.scss';

interface QueryResultProps {
  key: any;
  result: any;
  onCancelExecution: (blockUid: string, key: string) => void;
  onSelectResult: (key: string) => void;
}

const ErrorMessage = ({result}: any) => {
  const {errorMessage, executedSql, sql} = result.value.query || {};

  return (
    <>
      <div>{errorMessage}</div>
      <br/>
      <div>For request "{executedSql ? executedSql : sql}"</div>
    </>
  );
};

const CanceledMessage = ({result}: any) => {
  const {executedSql, sql} = result.value.query || {};

  return (
    <div>For request "{executedSql ? executedSql : sql}"</div>
  );
};

const QueryResult = ({
  result,
  onSelectResult,
  onCancelExecution,
}: QueryResultProps) => {
  if (!result) {
    return null;
  }
  return (
    <>
      <Result
        result={result}
        onCancelExecution={onCancelExecution}
        successElement={<ResultSuccess result={result}/>}
        failedTitle="Query run failed"
        failedDescription={<ErrorMessage result={result}/>}
        canceledTitle="Query Canceled"
        canceledDescription={<CanceledMessage result={result}/>}
      />
      <div className="query-result__footer">
        <SelectResult
          uid={result.block_uid}
          selected={result.key}
          onSelect={onSelectResult}
        />
        {result.status === EXECUTION_STATUS.SUCCESS && <div>{getRowsDuration(result?.value?.query)}</div>}
      </div>
    </>
  );
};

export default QueryResult;
